import React, { Component, Fragment } from 'react';
import InputField from '../../components/fields.component';
import categories from './categories.statics';
import { Modal, Form } from 'react-bootstrap';
import Spinner from '../../components/spinner.component';
import axios from 'axios';
import {MSG, allowedSize, allowedMimeTypes} from  '../../constants';

class EmaptaWorkspace extends Component {
	state = {
		formErrors: [],
		formData: {
			workspace_id: 2,
			first_name: { value: "", id: null, field_type: "", show: true },
			last_name: { value: "", id: null, field_type: "", show: true },
			mobile: { value: "", id: null, field_type: "", show: true },
			employee_id: { value: "", id: null, field_type: "", show: true },
			requester: { value: "", id: null, field_type: "", show: true },
			// type_of_inquiry: { value: "", id: null, field_type: "", show: true },
			tiers: { value: "", id: null, field_type: "", show: true },
			ticket_info: null,
			file: null,
			description: { value: "", id: null, field_type: "", show: true },
		},
		isAttachmentRequired: false,
		fileTemplates: null,
		attachmentMessages: [],
		formNotes: [],
		formFields: [],
		formStatus: {
			submitted: false
		},
		submitModal: {
			show: false
		},
		formErrorModal: {
			show: false,
			message: []
		},
		requiredFieldModal: {
			show: false,
		},
		page: {
			loaded: false
		}
	}

	componentDidMount = async () => {
		let { page, formData, formFields } = this.state;

		let fieldRequest = await this.getFields(2);

		if (fieldRequest.status) {

			fieldRequest.data.map(field => {

				let choices = field.choices;

				formFields.push({
					name: field.name,
					label_for_customers: field.label_for_customers,
					belongs_to_section: field.belongs_to_section,
					choices: choices,
					default_field: field.default_field,
					description: field.description,
					displayed_to_customers: field.displayed_to_customers,
					field_type: field.field_type,
					field_id: field.field_id,
					id: field.id,
					nested_fields: field.nested_fields,
					position: field.position,
					required_for_customers: field.required_for_customers,
					sections: field.sections,
				})
			});

			formFields.push({
				file: null
			});

			Object.keys(formData).map(key => {
				if (!['workspace_id', 'file', 'ticket_info'].includes(key)) {
					let field = formFields.find(form => form.name === key);
					if (field) {
						formData[key].id = field.id;
						formData[key].field_type = field.field_type;
					}
				}
			})

			page.loaded = true;
		}
		this.setState({ ...this.state, page, formData, formFields });
	}

	getFields = async () => {
		let request = await axios.get(`/api/tickets/get-fields?workspace=7`);
		return request.data;
	}

	inputChangeHandler = e => {
		let { formData, formErrors } = this.state;

		formData[e.target.name].value = e.target.value;

		//if tier is selected
		if (e.target.name === "tiers") {
			//set null
			formData.ticket_info = null;
			let categoryFields = categories[e.target.value.toLowerCase()];

			if (categoryFields) {

				//set ticket_details
				formData.ticket_info = {};
				if (categoryFields.length > 0) {

					categoryFields.map(field => {
						let findField = this.state.formFields.find(f => f.name === field);
						formData.ticket_info[findField.name] = {};
						formData.ticket_info[findField.name].id = findField.id;
						formData.ticket_info[findField.name].field_type = findField.field_type;
						formData.ticket_info[findField.name].value = "";
					})
				}
			}


		}

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	ticketInfoChangeHandler = e => {
		let { formData, formErrors, attachmentMessages, isAttachmentRequired, fileTemplates, formNotes } = this.state
		fileTemplates = null;
		formNotes = [];
		// isAttachmentRequired = false;
		// attachmentMessages = [];
		let additionalFields = [];
		let removeFields = [];
		// isAttachmentRequired = false;
		// formData.description.show = true;

		let field = this.state.formFields.find(form => form.name === e.target.name);
		if (field) {
			formData.ticket_info[field.name].id = field.id;
			formData.ticket_info[field.name].field_type = field.field_type;
			formData.ticket_info[field.name].value = e.target.value;
		} else {
			if (formData.ticket_info[e.target.name]) {
				formData.ticket_info[e.target.name].value = e.target.value;
			}
		}

		//Work related information

		if (field && ['main_cat', 'main_category'].includes(field.name)) {

			//remove civil_status_update or correction
			removeFields = [
				'civil_status_update', 'civil_status_correction',
				"first_name_correction", "last_name_correction",
				"updated_first_name", "updated_last_name",
				"maidenmiddle_name", "maiden_name",
				"permanent_address", "current_address",
				"topics_or_cocnern",
			];

			if (field.nested_fields && field.nested_fields.length > 0) {

				let nfield = "sc";
				if (e.target.name === "main_cat") nfield = "sc";
				if (e.target.name === "main_category") nfield = "sub_category";

				let findSc = field.nested_fields.find(nested_field => nested_field.name === nfield);

				if (findSc) {
					formData.ticket_info[findSc.name] = {}
					formData.ticket_info[findSc.name].id = findSc.id;
					formData.ticket_info[findSc.name].field_type = "custom";
					formData.ticket_info[findSc.name].value = "";
				}

			}
		}

		if (['sub_category'].includes(e.target.name)) {
			//get tiers

			let sub_category = [
				"full_name_of_receiving_managerapprover", "names_of_employees_to_be_transferred", "effective_date",
				"bank_name", "bank_account_number", "account_type", "valid_id",
				"type_of_allowance",
				"hmo_for_dep_or_own",
				"type_of_bonus",
				"name_of_establishmentrecipient_of_this_requirement", "name_of_dependent_if_applicable",
				"purpose_or_reason_for_multiple_employee_request",
				"certifications_topics_or_concerns"
			]
			this.removeFromFormData(sub_category, formData);

			let main_category = this.state.formFields.find(field => field.name === "main_category");

			if (["Single-Employee Request", "Reporting Line - Single-Employee Request", "Bank Account - Single-Employee Request", "Eligibility Correction or Update"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "no description needed";
				isAttachmentRequired = true;
				attachmentMessages = ["Proof of change request"];
				fileTemplates = "templates/Data Correction or Update_Single Employee_v2.xlsx"

				if (formData.ticket_info.hasOwnProperty("main_category") && formData.ticket_info.main_category.value === "Eligibility Correction or Update") {
					fileTemplates = "templates/Eligibility Correction Update_Single Employee_v2.xlsx"
				}

				if (e.target.value === "Reporting Line - Single-Employee Request") fileTemplates = "templates/Data Correction or Update_For Reporting Line_Single Employee Request_v2.xlsx"
				if (e.target.value === "Bank Account - Single-Employee Request") fileTemplates = "templates/For Bank Account_Single Employee_v2.xlsx"
				if (e.target.value === "Eligibility Correction or Update") fileTemplates = "templates/Eligibility Correction Update_Single Employee_v2.xlsx"
			}

			if (["Multiple-Employee Request", "Bank Account - Multiple-Employee Request", "Reporting Line - Multiple-Employee Request"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "";
				isAttachmentRequired = false;
				attachmentMessages = [];
				additionalFields = ["purpose_or_reason_for_multiple_employee_request"]
			}

			// if (["Reporting Line - Multiple-Employee Request"].includes(e.target.value)) {
			// 	formData.description.show = false;
			// 	formData.description.value = "";
			// 	isAttachmentRequired = false;
			// 	additionalFields = ["purpose_or_reason_for_multiple_employee_request"];
			// }

			//add a nested 
			if (['Separation', 'Job Level', "Employment Type", "Work Arrangement", "Entity", "Location", "Leaves Entitlement", "Premiums"].includes(e.target.value)) {

				if (main_category) {
					if (main_category.nested_fields && main_category.nested_fields.length > 0) {
						let topics_of_concern = main_category.nested_fields.find(nested => nested.name === "topics_or_cocnern");
						if (topics_of_concern) {
							formData.ticket_info[topics_of_concern.name] = {};
							formData.ticket_info[topics_of_concern.name].id = topics_of_concern.id;
							formData.ticket_info[topics_of_concern.name].field_type = "custom_dropdown";
							formData.ticket_info[topics_of_concern.name].value = "";
						}
					}
				}
			}

			// Show fields that are showing when a value is selected
			if (['Reporting Line', "Bank Account", 'Allowance', "Bonus/Commission", "HMO Entitlement"].includes(e.target.value)) {

				let reportingLineCategoriers = categories[e.target.value.toLowerCase()];

				if (reportingLineCategoriers && reportingLineCategoriers.length > 0) {
					reportingLineCategoriers.map(field => {
						let findFields = this.state.formFields.find(form => form.name === field)
						if (findFields) {
							formData.ticket_info[findFields.name] = {};
							formData.ticket_info[findFields.name].id = findFields.id;
							formData.ticket_info[findFields.name].field_type = findFields.field_type;
							formData.ticket_info[findFields.name].value = "";
						}
					})
				}
				//get right categoryes
			}
		}

		if (["purpose_or_reason_for_multiple_employee_request"].includes(e.target.name)) {
			isAttachmentRequired = true;
			attachmentMessages = ["Proof of change request"];
		}

		//./Work Related information

		if (['sc'].includes(e.target.name)) {
			formData.description.value = "";
			this.removeFromFormData([
				'civil_status_update', 'civil_status_correction',
				"permanent_address", "current_address",
				"topics_or_cocnern",
				"full_name_of_emergency_contact_person",
				"contact_details_of_emergency_contact_person",
				"relationship_to_declared_emergency_contact_person",

				"work_contact_details_category", "personal_contact_number_category",
				"email_address", "mobile_number"
			], formData);

			let main_category = categories[formData.ticket_info['main_cat'].value.toLowerCase()];
			if (main_category) {
				let sub_category = main_category[e.target.value.toLowerCase()]

				if (sub_category && sub_category.length > 0) {
					sub_category.map(field => {
						let findField = this.state.formFields.find(f => f.name === field);
						formData.ticket_info[findField.name] = {};
						formData.ticket_info[findField.name].id = findField.id;
						formData.ticket_info[findField.name].field_type = findField.field_type;
						formData.ticket_info[findField.name].value = "";
					})
				}
			}


			if (["Full Name"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "n/a";
				isAttachmentRequired = true;
				attachmentMessages = [
					"Proof of correction/update (Birth Certificate or Marrige Certificate)"
				]
				additionalFields = [
					"updated_first_name",
					"updated_last_name",
					"maidenmiddle_name",
					"maiden_name",
				]
			} else {
				this.removeFromFormData([
					"updated_first_name",
					"updated_last_name",
					"maidenmiddle_name",
					"maiden_name",
				], formData)
			}

			if (["Date of Birth"].includes(e.target.value)) {
				formData.description.show = false
				formData.description.value = "n/a";
				isAttachmentRequired = true;
				attachmentMessages = [
					"Proof of correction/update (Birth Certificate or Marrige Certificate)"
				]
			}

			if (["Gender"].includes(e.target.value)) {
				formData.description.show = false
				formData.description.value = "n/a";
				isAttachmentRequired = true;
				attachmentMessages = [
					"Proof of correction/update (Birth Certificate or Marrige Certificate)"
				]
			}


			if (["Emergency Contact Declaration"].includes(e.target.value)) {
				formData.description.show = false
				formData.description.value = "n/a";
				isAttachmentRequired = false;
				attachmentMessages = []
				additionalFields = ["full_name_of_emergency_contact_person", "contact_details_of_emergency_contact_person", "relationship_to_declared_emergency_contact_person"]
			}

			if (["Citizenship", 'Civil Status', "Residence Address", "Contact Details"].includes(e.target.value)) {
				formData.description.show = false
				formData.description.value = "";
				isAttachmentRequired = false;
				attachmentMessages = [];

				if (e.target.value === "Residence Address") {
					formData.description.show = true
					formData.description.value = "";
				}

				let mainCatField = this.state.formFields.find(field => field.name === "main_cat");
				if (mainCatField) {
					let topics_of_concern = mainCatField.nested_fields.find(nested => nested.name === "personal_information_cause_of_concern");
					if (topics_of_concern) {
						formData.ticket_info[topics_of_concern.name] = {};
						formData.ticket_info[topics_of_concern.name].id = topics_of_concern.id;
						formData.ticket_info[topics_of_concern.name].field_type = "custom_dropdown";
						formData.ticket_info[topics_of_concern.name].value = "";
					}
				}
				

			} else {
				this.removeFromFormData(["personal_information_cause_of_concern"], formData);
			}

		}

		if (["personal_information_cause_of_concern"].includes(e.target.name)) {

			this.removeFromFormData(["email_address", "mobile_number", "work_contact_details_category", "personal_contact_number_category"], formData)


			if (["Philippines", "Non-Philippines"].includes(e.target.value)) {
				isAttachmentRequired = false;
				attachmentMessages = []
				formData.description.show = true
				formData.description.value = "";

				if (e.target.value === "Non-Philippines") {
					isAttachmentRequired = true;
					attachmentMessages = ["Proof of nationality/citizenship"];
				}
			}

			if (["Single to Married", "Married to Separated", "Married to Widowed", "Widowed to Married"].includes(e.target.value)) {
				isAttachmentRequired = true;
				if (e.target.value === "Single to Married") attachmentMessages = ["Marriage certificate"];
				if (e.target.value === "Married to Separated") attachmentMessages = ["Decree of annulment"];
				if (e.target.value === "Married to Widowed") attachmentMessages = ["Death Certificate"];
				if (e.target.value === "Widowed to Married") attachmentMessages = ["Marriage certificate"];
			}

			if (["Current Address", "Permanent Address", "Both Permanent and Current Address"].includes(e.target.value)) {
				isAttachmentRequired = false;
				attachmentMessages = [];
				formData.description.show = false;
				formData.description.value = "no description needed";

				this.removeFromFormData(["current_address", "permanent_address"], formData)

				if (e.target.value === "Current Address") {
					additionalFields = ["current_address"];
				}

				if (e.target.value === "Permanent Address") {
					additionalFields = ["permanent_address"];
				}

				if (e.target.value === "Both Permanent and Current Address") {
					additionalFields = ["current_address", "permanent_address"];
				}
			}

			if (["Work Contact Details", "Personal Contact Number"].includes(e.target.value)) {
				isAttachmentRequired = false;
				attachmentMessages = [];
				formData.description.show = false;
				formData.description.value = "no description needed";

				this.removeFromFormData(["work_contact_details_category", "personal_contact_number_category"], formData)

				if (e.target.value === "Work Contact Details") {
					additionalFields = ["work_contact_details_category"];
				}

				if (e.target.value === "Personal Contact Number") {
					additionalFields = ["personal_contact_number_category"];
				}
			}
		}

		if (["work_contact_details_category", "personal_contact_number_category"].includes(e.target.name)) {
			this.removeFromFormData(["email_address", "mobile_number"], formData)

			if (e.target.value === "Email Address") additionalFields = ["email_address"]
			if (e.target.value === "Mobile Number") additionalFields = ["mobile_number"]
			if (e.target.value === "Both Email and Mobile Number") additionalFields = ["email_address", "mobile_number"]
		}

		// certification
		if (["certifications_main_category", "certifications_sub_category"].includes(e.target.name)) {
			additionalFields = [];
			attachmentMessages = [];
			isAttachmentRequired = false;
			attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature)"]
			formData.description.show = false;

			Object.keys(formData.ticket_info).map(key => {
				if (!["certifications_main_category", "certifications_sub_category"].includes(key)) {
					delete formData.ticket_info[key]
				}
			})

			let mainCategory = this.state.formFields.find(field => field.name === "certifications_main_category");
			if (e.target.name === "certifications_main_category") {
				let findSc = field.nested_fields.find(nested_field => nested_field.name === "certifications_sub_category");

				if (findSc) {
					formData.ticket_info[findSc.name] = {}
					formData.ticket_info[findSc.name].id = findSc.id;
					formData.ticket_info[findSc.name].field_type = "custom";
					formData.ticket_info[findSc.name].value = "";
				}
			}

			if (e.target.name === "certifications_sub_category") {
				let fields = [];

				if (['HMO'].includes(e.target.value)) {
					attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature)"];


					if (mainCategory) {
						if (mainCategory.nested_fields && mainCategory.nested_fields.length > 0) {
							let topics_of_concern = mainCategory.nested_fields.find(nested => nested.name === "certifications_topics_or_concerns");
							if (topics_of_concern) {
								formData.ticket_info[topics_of_concern.name] = {};
								formData.ticket_info[topics_of_concern.name].id = topics_of_concern.id;
								formData.ticket_info[topics_of_concern.name].field_type = "custom_dropdown";
								formData.ticket_info[topics_of_concern.name].value = "";
							}
						}
					}

					formData.description.show = false;
					formData.description.value = "";
					isAttachmentRequired = true;
					attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature)"];
					//
				}

				if (["SSS", "HDMF", "PhilHealth", "2316 (Emapta)"].includes(e.target.value)) {
					attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature). "]
					isAttachmentRequired = true;
					formData.description.show = false;
					formData.description.value = "";
				}

				if (["SSS Unemployment", "SSS Sickness No Cash Advance", "SSS Maternity No Cash Advance"].includes(e.target.value)) {
					attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature)"]
					isAttachmentRequired = true;
					formData.description.show = false;
					formData.description.value = "";
				}

				if (["GLI"].includes(e.target.value)) {
					fields = categories[e.target.value.toLowerCase()];
					formNotes = ["This will only cover the EMAPTA specific coverage"];
					attachmentMessages = ["Proof of identity (Valid ID with Picture and Signature)"];
					isAttachmentRequired = true;
				}

				if (fields && fields.length > 0) {
					fields.map(field => {
						let findFields = this.state.formFields.find(form => form.name === field)
						if (findFields) {
							formData.ticket_info[findFields.name] = {};
							formData.ticket_info[findFields.name].id = findFields.id;
							formData.ticket_info[findFields.name].field_type = findFields.field_type;
							formData.ticket_info[findFields.name].value = "";
						}
					})
				}
			}
		}

		if (["certifications_topics_or_concerns"].includes(e.target.name)) {
			formNotes = ["This will only cover the EMAPTA specific coverage"];
			if (["Dependent"].includes(e.target.value)) {
				additionalFields = ["name_of_dependent_if_applicable"]
			} else {
				removeFields = ["name_of_dependent_if_applicable"];
			}
		}
		// ./Certificaitons

		//benefits
		if (["benefits_claims_amp_processing_sub_category", "benefits_claims_amp_processing_topics_or_concern"].includes(e.target.name)) {
			let mainCategory = this.state.formFields.find(field => field.name === "benefits_claims_amp_processing_sub_category");
			additionalFields = [];
			// attachmentMessages = ["Proof of identity (Valid ID with picture & signature)"];

			if (e.target.name === "benefits_claims_amp_processing_sub_category") {
				isAttachmentRequired = true;
				formData.description.show = false;
				let fieldsToBeRemoved = ["benefits_claims_amp_processing_cause_of_concern", "reason_for_deduction_stoppage_amp_payment_adjustment", "effective_date_start_of_deduction", "effective_date_stop_of_deduction", "category_of_filing", "category_of_filing"];
				this.removeFromFormData(fieldsToBeRemoved, formData);

				//2nd level show and hide of fields
				if (mainCategory.nested_fields && mainCategory.nested_fields.length > 0) {
					let topics_or_concern = mainCategory.nested_fields.find(nested => nested.name === "benefits_claims_amp_processing_topics_or_concern");
					if (topics_or_concern) {
						formData.ticket_info[topics_or_concern.name] = {};
						formData.ticket_info[topics_or_concern.name].id = topics_or_concern.id;
						formData.ticket_info[topics_or_concern.name].field_type = "custom_dropdown";
						formData.ticket_info[topics_or_concern.name].value = "";
					}

					if (["Statutory Loans"].includes(e.target.value)) {
						additionalFields = categories[e.target.value.toLowerCase()];
					}
				}

				if (["Statutory Numbers", "Statutory Leaves"].includes(e.target.value)) {
					formData.description.show = false;
					formData.description.value = "no description needed";
					isAttachmentRequired = true;
					attachmentMessages = [
						"Proof of Online Filing Screenshot",
						"Softcopy of Accomplished Forms",
						"Soft copy of SOA or Cheque Voucher",
						"Valid Proof of DSWD ID or Certification",
						"Valid Proof of Medical Records plus SSS Sickness",
						"Valid Proof of Birth Certification plus SSS Mat",
						"Valid Proof of SSS Mat & Medical Records",
						"Valid Proof of Barangay Certification",
						"Valid Proof of Number",
						"Screenshot of Leaves Balance",
						"All other supporting Medical Docs",
					]
				}

				if (["Statutory Loans"].includes(e.target.value)) {
					attachmentMessages = ["PROOF OF IDENTITY (Valid ID with picture & signature) plus SCREENSHOT PROOF of FORM LOAN per page"];
					isAttachmentRequired = true;
				}

			}

			if (e.target.name === "benefits_claims_amp_processing_topics_or_concern") {
				let fieldsToBeRemoved = ["category_of_filing", "category_of_delivery"];
				this.removeFromFormData(fieldsToBeRemoved, formData);

				if (mainCategory.nested_fields && mainCategory.nested_fields.length > 0) {
					let topics_of_concern = mainCategory.nested_fields.find(nested => nested.name === "benefits_claims_amp_processing_cause_of_concern");
					if (topics_of_concern) {

						let keyValues = Object.entries(formData.ticket_info);
						let findTopicsOrConcern = keyValues.findIndex(key => key.includes("benefits_claims_amp_processing_topics_or_concern"));
						if (findTopicsOrConcern) {
							keyValues.splice(findTopicsOrConcern + 1, 0, [topics_of_concern.name, {}]);
							formData.ticket_info = Object.fromEntries(keyValues)
							formData.ticket_info[topics_of_concern.name].id = topics_of_concern.id;
							formData.ticket_info[topics_of_concern.name].field_type = "custom_dropdown";
							formData.ticket_info[topics_of_concern.name].value = "";
						} else {
							formData.ticket_info[topics_of_concern.name] = {};
							formData.ticket_info[topics_of_concern.name].id = topics_of_concern.id;
							formData.ticket_info[topics_of_concern.name].field_type = "custom_dropdown";
							formData.ticket_info[topics_of_concern.name].value = "";
						}
					}
				}

				if (["SSS Sickness"].includes(e.target.value)) {
					additionalFields = ["category_of_filing"];
					formData.description.show = false;
					formData.description.value = "no description needed";
					isAttachmentRequired = true;
					attachmentMessages = [
						"Proof of Online Filing Screenshot",
						"Softcopy of Accomplished Forms",
						"Soft copy of SOA or Cheque Voucher",
						"Valid Proof of DSWD ID or Certification",
						"Valid Proof of Medical Records plus SSS Sickness",
						"Valid Proof of Birth Certification plus SSS Mat",
						"Valid Proof of SSS Mat & Medical Records",
						"Valid Proof of Barangay Certification",
						"Valid Proof of Number",
						"Screenshot of Leaves Balance",
						"All other supporting Medical Docs",
					]
				}

				if (["SSS Maternity", "SSS EC", "Maternity Salary Differential"].includes(e.target.value)) {

					if (e.target.value === "SSS EC") {
						this.removeFromFormData(["category_of_delivery"], formData);
						
					} else {
						additionalFields = ["category_of_delivery"]
					}
					formData.description.show = false;
					formData.description.value = "no description needed";
					isAttachmentRequired = true;
					attachmentMessages = [
						"Proof of Online Filing Screenshot",
						"Softcopy of Accomplished Forms",
						"Soft copy of SOA or Cheque Voucher",
						"Valid Proof of DSWD ID or Certification",
						"Valid Proof of Medical Records plus SSS Sickness",
						"Valid Proof of Birth Certification plus SSS Mat",
						"Valid Proof of SSS Mat & Medical Records",
						"Valid Proof of Barangay Certification",
						"Valid Proof of Number",
						"Screenshot of Leaves Balance",
						"All other supporting Medical Docs",
					]

				}

				let hmo = [
					"Employee",
					"Dependent",
				]
				if (hmo.includes(e.target.value)) {
					formData.description.show = false;
					formData.description.value = "no description needed";
					isAttachmentRequired = true;
					attachmentMessages = ["Proof of identity (Valid ID with picture and signature)"];
				}
			}

		}

		if (["benefits_claims_amp_processing_cause_of_concern"].includes(e.target.name)) {
			formData.description.show = false;
			formData.description.value = "no description needed";
			additionalFields = []
			let fieldsToBeRemoved = [
				"increase_the_deduction_amount", "deduction_amount_per_cutoff", "effective_date_start"
			]
			this.removeFromFormData(fieldsToBeRemoved, formData);

			if (["Online Approval of Loan"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "no description needed";
			}

			if (["Manual Approval of Loan"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "no description needed";
			}

			if (["Salary Deduction Start"].includes(e.target.value)) {
				formData.description.show = false;
				formData.description.value = "no description needed";
				attachmentMessages = ["PROOF OF IDENTITY (Valid ID with picture & signature) plus SCREENSHOT PROOF of FORM LOAN per page"];
				additionalFields = ["increase_the_deduction_amount"]
			}

			if (["Salary Deduction Stop"].includes(e.target.value)) {
				formData.description.show = true;
				formData.description.value = "";
				attachmentMessages = ["Proof of identity (Valid ID with picture and signature)", "Screenshot proof of SOA Loan"];
			}

			if (["Payment Posting"].includes(e.target.value)) {
				formData.description.show = true;
				formData.description.value = "";
				attachmentMessages = ["PROOF OF IDENTITY (Valid ID with picture & signature) plus SCREENSHOT PROOF of FORM LOAN per page"];
			}

			if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_sub_category") && formData.ticket_info.benefits_claims_amp_processing_sub_category.value === "Medical Insurance or HMO") {
				if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_topics_or_concern") && formData.ticket_info.benefits_claims_amp_processing_topics_or_concern.value === "Employee") {
					if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_cause_of_concern") && formData.ticket_info.benefits_claims_amp_processing_cause_of_concern.value === "Membership Issues") {
						formData.description.show = true;
						formData.description.value = "";
					}
				}

				if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_topics_or_concern") && formData.ticket_info.benefits_claims_amp_processing_topics_or_concern.value === "Dependent") {
					if ([
						"Deduction Concern",
						"Membership Issues",
						"Membership Status",
						"Membership Number Inquiry"
					].includes(e.target.value)) {
						formData.description.show = true;
						formData.description.value = "";
					}
				}
			}

			if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_sub_category") && formData.ticket_info.benefits_claims_amp_processing_sub_category.value === "Mutual Fund") {
				if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_topics_or_concern") && formData.ticket_info.benefits_claims_amp_processing_topics_or_concern.value === "Employee") {
					if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_cause_of_concern") && formData.ticket_info.benefits_claims_amp_processing_cause_of_concern.value === "Issues") {
						formData.description.show = true;
						formData.description.value = "";
					}
				}
			}

			if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_sub_category") && formData.ticket_info.benefits_claims_amp_processing_sub_category.value === "Group Life Insurance") {
				if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_topics_or_concern") && formData.ticket_info.benefits_claims_amp_processing_topics_or_concern.value === "Dependent") {
					if (formData.ticket_info.hasOwnProperty("benefits_claims_amp_processing_cause_of_concern") && formData.ticket_info.benefits_claims_amp_processing_cause_of_concern.value === "Issues") {
						formData.description.show = true;
						formData.description.value = "";
					}
				}
			}


		}

		if (["increase_the_deduction_amount"].includes(e.target.name)) {
			if (e.target.value === "YES") {
				additionalFields = ["deduction_amount_per_cutoff", "effective_date_start"]
			} else {
				this.removeFromFormData(["deduction_amount_per_cutoff", "effective_date_start"], formData)
			}
		}
		//.benefits


		// pay affecting
		
		if (["pay_affecting_category", "pay_affecting_sub_category"].includes(e.target.name)) {
			formData.description.show = false;
			let mainCategory = this.state.formFields.find(field => field.name === "pay_affecting_category");

			if (["pay_affecting_category"].includes(e.target.name)) {
				let topics_or_concern = mainCategory.nested_fields.find(nested => nested.name === "pay_affecting_sub_category");
				if (topics_or_concern) {
					formData.ticket_info[topics_or_concern.name] = {};
					formData.ticket_info[topics_or_concern.name].id = topics_or_concern.id;
					formData.ticket_info[topics_or_concern.name].field_type = "custom_dropdown";
					formData.ticket_info[topics_or_concern.name].value = "";
				}
				removeFields = ["pay_affecting_cause_of_concern"];
			}

			if (['pay_affecting_sub_category'].includes(e.target.name)) {
				// this.removeFromFormData(["pay_affecting_cause_of_concern", "pay_period_affected"], formData);
				this.removeFromFormData(["pay_affecting_cause_of_concern", "pay_period_affected", "specific_dates_affected", "hours_to_be_covered_per_day", "type_of_special_leave", "total_hours_expected", "total_days_to_be_covered", "type_of_holiday", "start_date", "end_date", "rest_days_amp_new_schedule", "amount_involved", "names_of_referral", "name_and_eid_of_affected_employee", "type_of_hours_for_approval"], formData)

				if (mainCategory.nested_fields && mainCategory.nested_fields.length > 0) {
					let topics_of_concern = mainCategory.nested_fields.find(nested => nested.name === "pay_affecting_cause_of_concern");
					if (topics_of_concern) {
						let pay_affecting_cause_of_concern = {
							id: topics_of_concern.id,
							field_type: "custom_dropdown",
							value: "",
						}
						let payAffectingValue = Object.entries(formData.ticket_info);
						let findTopicsOrConcern = payAffectingValue.findIndex(key => key.includes("pay_affecting_sub_category"));
						if (findTopicsOrConcern >= 0) {
							let objectToArray = Object.entries(formData.ticket_info);
							objectToArray.splice(findTopicsOrConcern + 1, 0, ["pay_affecting_cause_of_concern", pay_affecting_cause_of_concern]);
							formData.ticket_info = Object.fromEntries(objectToArray)
						} else {
							formData.ticket_info["pay_affecting_cause_of_concern"] = pay_affecting_cause_of_concern;
						}
					}
				}

			}
		}

		if (["pay_affecting_cause_of_concern"].includes(e.target.name)) {
			formData.description.show = true;
			formData.description.value = "";
			attachmentMessages = [];
			isAttachmentRequired = false;

			this.removeFromFormData(["pay_period_affected", "specific_dates_affected", "hours_to_be_covered_per_day", "type_of_special_leave", "total_hours_expected", "total_days_to_be_covered", "type_of_holiday", "start_date", "end_date", "rest_days_amp_new_schedule", "amount_involved", "names_of_referral", "name_and_eid_of_affected_employee", "type_of_hours_for_approval"], formData)

			let selectedValues = [
				"Failed to File or Certify",
				"Late Filing",
				"Pending Approval",
				"Cancelled",
				"Filed but Uncaptured",
				"Cannot File or Cancel",
				"Cannot Certify",
				"Not Showing in Empower",
				"Pending Approval Manager",
				"Pending Approval HR",
				"Uncaptured",
				"Incorrect Balance or Accrual",
				"Filed but Uncaptured or Not Showing in Empower",
				"Failed to Adjust Schedule",
				"Special Calculation",
				"Pending Approval",
				"Uncaptured or Not Showing in Empower",
				"Approved Grace Period",
				"New Hire",
				"Failed to File as Leave",
				"Full Flexi",
				"Special Approval",
				"System Limitation",
				"Cannot File, Edit or Cancel",
				"Late Filing or Certification",
				"Calculation Inquiry",
				"Amount Concern"
			];

			if (selectedValues.includes(e.target.value)) {
				formData.description.show = true;
				formData.description.value = "";
				additionalFields = ["pay_period_affected", "specific_dates_affected", "hours_to_be_covered_per_day"]
				isAttachmentRequired = true;
				attachmentMessages = [
					"Copy of Approval (Manager or HRBP or CXM)",
					"Copy of Payslip (only if no access to payroll tool)",
					"Copy of Approval for Special Calculation",
					"Copy of Approval from Benefits team",
					"Copy of Confirmation (Manager or HRBP or CXM)",
					"Copy of ATD (for Scheduled Deduction & Stoppage)",
					"Copy of Agreement",
					"Email Communications",
					"PANF",
				]

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Solo Parent Leave", "Maternity Leave", "Paternity Leave", "Magna Carta", "VAWC Leave"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "specific_dates_affected", "total_days_to_be_covered"]
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Cash Conversion"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "total_hours_expected"]
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["SIL"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "total_days_to_be_covered"]
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Holiday"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "type_of_holiday", "specific_dates_affected", "hours_to_be_covered_per_day"];
				}

				if (["Cannot File or Cancel", "Cannot Certify", "Not Showing in Empower"].includes(e.target.value)) {
					additionalFields = ["pay_period_affected", "specific_dates_affected", "total_hours_expected"];

					if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category")) {
						if (["Vacation Leave", "Time Off in Lieu (TOIL)", "Emergency Leave", "Client Specific Leave"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
							additionalFields = ["pay_period_affected", "specific_dates_affected"];

							if (formData.ticket_info.pay_affecting_sub_category.value === "Client Specific Leave") {
								additionalFields.push("type_of_special_leave");
							}
						}
					}
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Change Shift or Schedule"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["start_date", "end_date", "rest_days_amp_new_schedule"]
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["In and Out Amendment"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "specific_dates_affected", "hours_to_be_covered_per_day"];
				}

				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Tax Deduction", "Tax Refund"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected"]
				}

			}

			if (["Scheduled Implementation Concern", "Unpaid Adjustment"].includes(e.target.value)) {

				isAttachmentRequired = true;
				formData.description.show = true;
				formData.description.value = "";
				additionalFields = ["pay_period_affected"];
				attachmentMessages = [
					"Copy of Approval (Manager or HRBP or CXM)",
					"Copy of Payslip (only if no access to payroll tool)",
					"Copy of Approval for Special Calculation",
					"Copy of Approval from Benefits team",
					"Copy of Confirmation (Manager or HRBP or CXM)",
					"Copy of ATD (for Scheduled Deduction & Stoppage)",
					"Copy of Agreement",
					"Email Communications",
					"PANF",
				]


				if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Employee Referral"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
					additionalFields = ["pay_period_affected", "amount_involved", "names_of_referral"];
				}
			}

			//13 month pay and Special Arrangements
			if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["13th Month Pay", "Special Arrangements"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
				isAttachmentRequired = true;
				formData.description.show = true;
				formData.description.value = "";
				attachmentMessages = [
					"Copy of Approval (Manager or HRBP or CXM)",
					"Copy of Payslip (only if no access to payroll tool)",
					"Copy of Approval for Special Calculation",
					"Copy of Approval from Benefits team",
					"Copy of Confirmation (Manager or HRBP or CXM)",
					"Copy of ATD (for Scheduled Deduction & Stoppage)",
					"Copy of Agreement",
					"Email Communications",
					"PANF",
				]
				additionalFields = ["pay_period_affected"];
			}

			if (formData.ticket_info.hasOwnProperty("pay_affecting_sub_category") && ["Staff DTR"].includes(formData.ticket_info.pay_affecting_sub_category.value)) {
				isAttachmentRequired = true;
				formData.description.show = true;
				formData.description.value = "";
				attachmentMessages = [
					"Copy of Approval (Manager or HRBP or CXM)",
					"Copy of Payslip (only if no access to payroll tool)",
					"Copy of Approval for Special Calculation",
					"Copy of Approval from Benefits team",
					"Copy of Confirmation (Manager or HRBP or CXM)",
					"Copy of ATD (for Scheduled Deduction & Stoppage)",
					"Copy of Agreement",
					"Email Communications",
					"PANF",
				]
				additionalFields = ["pay_period_affected", "specific_dates_affected", "type_of_hours_for_approval", "name_and_eid_of_affected_employee"];
			}
		}
		// ./pay affecting

		if (additionalFields && additionalFields.length > 0) {
			additionalFields.map(field => {
				let findFields = this.state.formFields.find(form => form.name === field)
				if (findFields) {
					formData.ticket_info[findFields.name] = {};
					formData.ticket_info[findFields.name].id = findFields.id;
					formData.ticket_info[findFields.name].field_type = findFields.field_type;
					formData.ticket_info[findFields.name].value = "";
				}
			})
		}

		removeFields.map(removeField => {
			if (formData.ticket_info.hasOwnProperty(removeField)) {
				delete formData.ticket_info[removeField]
			}
		})

		if (formErrors.includes(e.target.name)) {
			let idx = formErrors.indexOf(e.target.name);
			formErrors.splice(idx, 1);
		}

		

		this.setState({ ...this.state, formData, formErrors, attachmentMessages, isAttachmentRequired, fileTemplates, formNotes });
	}

	removeFromFormData = (fields, formData) => {
		return fields.map(removeField => {
			if (formData.ticket_info.hasOwnProperty(removeField)) {
				delete formData.ticket_info[removeField]
			}
		})
	}

	additionalFields = (fields, formdata) => {
		if (fields && fields.length > 0) {
			return fields.map(field => {
				let findFields = this.state.formFields.find(form => form.name === field)
				if (findFields) {
					formdata.ticket_info[findFields.name] = {};
					formdata.ticket_info[findFields.name].id = findFields.id;
					formdata.ticket_info[findFields.name].field_type = findFields.field_type;
					formdata.ticket_info[findFields.name].value = "";
				}
			})
		}
	}

	attachFileHandler = (e, fileIdx) => {
		let { formData, formErrors, formErrorModal } = { ...this.state };
		let files = e.target.files;
		let error = [];
		let fileTypeError = false;
		let  fileSize = 0;
		for (let i = 0; i < files.length; i++) {
			fileSize = fileSize + files[i].size; 
			if(!allowedMimeTypes.includes(files[i].type)) {
				fileTypeError= true;
			}

		}

		if(fileTypeError==true) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileType.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileType.message}</p>);

		}else if (fileSize > allowedSize) {
			formErrorModal.show = true;
			formErrorModal.message = [];
			formErrorModal.message.push(<h3>{MSG.fileSize.title}</h3>);
			formErrorModal.message.push(<p>{MSG.fileSize.message}</p>);
		
		} else {
			if (formErrors.includes(`${fileIdx}_file`)) {
				let fIdx = formErrors.indexOf(`${fileIdx}_file`);
				formErrors.splice(fIdx, 1);
			}
			formData.file = files
		}

		this.setState({ ...this.state, formData, formErrors });
	}

	removeAttachment = (e, idx) => {
		e.preventDefault();
		let formData = this.state.formData;
		formData.file = Array.from(formData.file);
		formData.file.splice(idx, 1);
		this.setState({ formData });
	}

	validateEmail = (email) => {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
			);
	};

	submitForm = e => {
		e.preventDefault();
		let { formData, formErrors, formStatus, isAttachmentRequired, requiredFieldModal } = this.state;

		formErrors = [];

		if (isAttachmentRequired) {
			if (!formData.file || formData.file.length <= 0) {
				if (!formErrors.includes('file')) formErrors.push("file");
			}
		}

		Object.keys(formData).map(key => {

			let findField = this.state.formFields.find(field => field.name === key);
			if (findField) {
				if (findField.required_for_customers && formData[key].value === '') formErrors.push(key);
			}

			if (key === "description") {
				if (formData[key].show === false) {
					formData[key].value = "no description needed";
					formErrors = formErrors.filter(e=>e != 'description')

				}
			}

			if (key === 'requester') {
				let isEmail = this.validateEmail(formData[key].value);
				if (!isEmail) {
					if (!formErrors.includes(key)) formErrors.push(key)
				}
			}
		})

		if (formData.ticket_info !== null) {
			Object.keys(formData.ticket_info).map(key => {

				let findField = this.state.formFields.find(field => field.name === key);
				if (findField) {
					if (findField.required_for_customers && formData.ticket_info[key].value === '') formErrors.push(key);
				} else {

					//topics or concern ids
					if ([22000007660, 22000007666].includes(formData.ticket_info[key].id)) {
						if (formData.ticket_info[key].value === '') formErrors.push(key);
					}
				}
			})
		}

		formStatus.submitted = formErrors.length > 0 ? false : true;
		requiredFieldModal.show = formErrors.length > 0 ? true : false;
		this.setState({ ...this.state, formErrors, formStatus, requiredFieldModal }, () => {
			if (this.state.formErrors.length < 1) this.sendForm()
		});
	}

	sendForm = () => {
		let formData = this.state.formData;
		let FD = new FormData();

		if (formData.file !== null) {
			for (const key of Object.keys(formData.file)) {
				FD.append('file', formData.file[key], formData.file[key].name);
			}
		}

		Object.keys(formData).map(key => {
			if (!['file', 'ticket_info'].includes(key)) {
				FD.append(key, JSON.stringify(formData[key]));
			}
		})

		if (formData.ticket_info !== null) {
			Object.keys(formData.ticket_info).map(key => {
				FD.append(key, JSON.stringify(formData.ticket_info[key]));
			})
		}

		return axios.post('/api/tickets', FD)
			.then(response => {
				let { formStatus, submitModal } = this.state
				formStatus.submitted = false;
				submitModal.show = true;
				return this.setState({ ...this.state, formStatus, submitModal });
			}).catch(err => {
				let { errors } = err.response.data;
				let { formStatus, formErrorModal } = { ...this.state }

				formErrorModal.show = true;
				formStatus.submitted = false;

				formErrorModal.message = [];
				formErrorModal.message.push(<h3>Form did not submit</h3>)

				if (errors && errors.hasOwnProperty('errors') && errors.errors.length > 0) {
					errors.errors.map((error, idx) => {
						formErrorModal.message.push(<p key={idx}>{error.message}</p>);
					})
				}
				return this.setState({ ...this.state, formStatus });
			})

	}

	closeSubmitModal = e => {
		e.preventDefault();
		window.location.reload();
	}

	closeErrorModal = e => {
		e.preventDefault();
		let { formErrorModal } = this.state;
		formErrorModal.show = false;
		formErrorModal.message = "";
		this.setState({ ...this.state, formErrorModal });
	}

	closeRequiredFieldModal = e => {
		e.preventDefault();
		let { requiredFieldModal } = this.state;
		requiredFieldModal.show = false;
		this.setState({ ...this.state, requiredFieldModal });
	}

	displayField = (field) => {
		let { formErrors, formStatus, formData } = this.state;
		let findField = this.state.formFields.find(formData => formData.name === field);

		if (!formData.hasOwnProperty(field)) return null
		if (findField) return <InputField field={findField} value={formData[findField.name].value} show={formData[findField.name].show} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.inputChangeHandler(e)} />
		return null;
	}

	displayTicketInfo = (ticket_info) => {
		let { formErrors, formStatus, formData } = this.state;

		let elements = [];
		Object.keys(ticket_info).map((key, idx) => {
			let findField = this.state.formFields.find(formData => formData.name === key);

			let nestedElements = [];
			if (findField && ["main_cat", "main_category", 'sub_category', "certifications_main_category", "benefits_claims_amp_processing_sub_category", "pay_affecting_category"].includes(findField.name)) {

				if (formData.ticket_info[findField.name].value !== "") {
					//select choices
					let findChoices = findField.choices.find(choice => choice.value === formData.ticket_info[findField.name].value);

					//select sc as subcategory
					let sc = findField;

					if (findField.nested_fields && findField.nested_fields.length > 0) {

						let fName = "sc";
						if (findField.name === "main_cat") fName = "sc";
						if (findField.name === "main_category") fName = "sub_category";
						if (findField.name === "certifications_main_category") fName = "certifications_sub_category";
						if (findField.name === "benefits_claims_amp_processing_sub_category") fName = "benefits_claims_amp_processing_topics_or_concern";
						if (findField.name === "pay_affecting_category") fName = "pay_affecting_sub_category";
						// if (findField.name === "pay_affecting_category") fName = "pay_affecting_sub_category";

						let findSc = findField.nested_fields.find(nested_field => nested_field.name === fName);
						let label = formData.tiers.value + " Topics or Concern";

						if (findSc) {
							sc = {
								...findSc,
								field_type: 'custom_dropdown',
								name: fName,
								label_for_customers: label,
								required_for_customers: true
							};
						}
					}

					if (findChoices) {
						nestedElements.push(
							<div className="col-12" key={findChoices.display_id}>
								<InputField
									className={null}
									choices={findChoices.nested_options}
									field={sc}
									value={formData.ticket_info[sc.name].value}
									formErrors={formErrors}
									formStatus={formStatus}
									inputChangeHandler={e => this.ticketInfoChangeHandler(e)}
								/>
							</div>
						)
					}
				}
			}

			//third level of dropdown
			if (["topics_or_cocnern", "certifications_topics_or_concerns", "benefits_claims_amp_processing_cause_of_concern", "pay_affecting_cause_of_concern", 'personal_information_cause_of_concern'].includes(key)) {
				//get main category

				let selectedKey = "main_category";
				if (key === "certifications_topics_or_concerns") selectedKey = "certifications_main_category";
				if (key === "topics_or_cocnern") selectedKey = "main_category";
				if (key === "benefits_claims_amp_processing_cause_of_concern") selectedKey = "benefits_claims_amp_processing_sub_category";
				if (key === "pay_affecting_cause_of_concern") selectedKey = "pay_affecting_category";
				if (key === "personal_information_cause_of_concern") selectedKey = "main_cat";


				let subCategory = "sub_category";
				if (key === "certifications_topics_or_concerns") subCategory = "certifications_sub_category";
				if (key === "topics_or_cocnern") subCategory = "sub_category";
				if (key === "benefits_claims_amp_processing_cause_of_concern") subCategory = "benefits_claims_amp_processing_topics_or_concern";
				if (key === "pay_affecting_cause_of_concern") subCategory = "pay_affecting_sub_category";
				if (key === "personal_information_cause_of_concern") subCategory = "sc";

				let mainCategory = this.state.formFields.find(formData => formData.name === selectedKey);

				//get selected choice
				if (mainCategory) {
					let selectedMainCategory = formData.ticket_info.hasOwnProperty(selectedKey) ? formData.ticket_info[selectedKey].value : null;
					let selectedMainCategoryOption = mainCategory.choices.find(choice => choice.value === selectedMainCategory);
					if (selectedMainCategoryOption) {
						let selectedSubcategory = formData.ticket_info.hasOwnProperty(subCategory) ? formData.ticket_info[subCategory].value : null;
						let nestedOptions = selectedMainCategoryOption.nested_options.find(nested => nested.value === selectedSubcategory);

						let includeFields = [
							"Separation",
							"Job Level",
							"Employment Type",
							'Work Arrangement',
							"Entity",
							"Location",
							"Leaves Entitlement",
							"Premiums",
							"HMO",
							"PhilHealth",
							'Own',
							"Employee",
							"Dependent",
							"HDMF Multipurpose",
							"HDMF Calamity",
							"SSS Salary",
							"SSS Calamity",
							"SSS Sickness",
							"SSS Maternity",
							"SSS EC",
							"Maternity Salary Differential",
							"SSS", "HDMF", "BIR",
							"Citizenship",
							"Residence Address",
							"Contact Details",

							"Sick Leave",
							"Vacation Leave",
							"Time Off in Lieu (TOIL)",
							"Emergency Leave",
							"Client Specific Leave",
							"Bereavement Leave",
							"Solo Parent Leave",
							"Maternity Leave",
							"Paternity Leave",
							"Solo Parent",
							"Magna Carta",
							"VAWC",
							"VAWC Leave",
							"Paternity",
							"Maternity",
							"Cash Conversion",
							"SIL",

							"Civil Status",
							"Base Pay",
							"Allowance",
							"Bonus or Incentive",
							"Overtime",
							"Rest Day",
							"Night Differential",
							"Holiday",
							"Tardiness",
							"Undertime",

							"Double Shift",
							"Compressed Work",
							"Change Shift or Schedule",
							"In and Out Amendment",

							"Tax Deduction",
							"Tax Refund",
							"Employee Referral",

							"13th Month Pay",
							"Special Arrangements",
							"Staff DTR"
						]

						if (nestedOptions && includeFields.includes(nestedOptions.value)) {

							let sc = {
								id: key,
								name: key,
								field_type: 'nested_field',
								label_for_customers: `${formData.tiers.value} Cause of Concern`,
								required_for_customers: true
							}

							elements.push(
								<div className="col-12" key={selectedSubcategory.id}>
									<InputField
										className={null}
										choices={nestedOptions.nested_options}
										field={sc}
										value={formData.ticket_info[sc.name].value}
										formErrors={formErrors}
										formStatus={formStatus}
										inputChangeHandler={e => this.ticketInfoChangeHandler(e)}
									/>
								</div>
							)
						}
					}

				}
			}

			if (findField) {

				if (key === "mobile_number") {
					
				}
				elements.push(
					<>
						<div key={idx} className="col-12">
							<InputField className={null} field={findField} value={formData.ticket_info[key].value} formErrors={formErrors} formStatus={formStatus} inputChangeHandler={e => this.ticketInfoChangeHandler(e)} />
						</div>
						{nestedElements}
					</>
				)
			}
		})
		return elements;
	}

	displayAttachedFiles = () => {
		let formData = this.state.formData;

		let data = [];


		if (formData.file.length > 0) {

			for (let i = 0; i < formData.file.length; i++) {
				data.push(
					<div className="chip" key={i}>
						<span>{formData.file[i].name}</span>
						<a
							href="#"
							className="close"
							onClick={e => this.removeAttachment(e, i)}
						>
							<i className="bi bi-x"></i>
						</a>
					</div>
				)
			}
		}

		return data;
	}

	render() {
		let { formData, formErrors, formStatus, submitModal, formErrorModal, page, attachmentMessages, isAttachmentRequired, fileTemplates, formNotes, requiredFieldModal, formFields } = this.state;
		return page.loaded ? (
			<>
				<div className='row'>
					<div className='col-12'>
						<label>Search For Knowledge Based Solutions</label>
						<input className='form-control' placeholder='Coming Soon...' disabled={true} />
					</div>
				</div>

				<h4 style={{ color: '#ffffff' }}>
					In order for us to address your concerns accurately and efficiently, we kindly request that you provide us with the following information. This will enable us to expedite our response to your concern.
				</h4>

				<div className='row'>
					<div className="col-lg-6 col-md-6 col-xs-12">
						{this.displayField("first_name")}
					</div>
					<div className="col-lg-6 col-md-6 col-xs-12">
						{this.displayField("last_name")}
					</div>

					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("mobile")}
					</div>


					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("employee_id")}
					</div>

					<div className="col-12 col-xs-12 mt-3">
						{this.displayField("requester")}
					</div>
				</div>

				<div className='row' style={{ marginBottom: '50px' }}>
					<h4 style={{ marginTop: '50px', color: '#ffffff' }}>How can we help you today?</h4>

					{/* <div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("type_of_inquiry")}
					</div> */}
					<div className="col-lg-6 col-md-6 col-xs-12 mt-3">
						{this.displayField("tiers")}
					</div>

					{formData.ticket_info !== null ?
						this.displayTicketInfo(formData.ticket_info)
						: null
					}

					<div className="col-lg-12 col-md-12 col-xs-12 mt-3">
						{this.displayField("description")}
					</div>

					{formNotes.length > 0 ?
						<div className='col-12'>
							<p>
								<strong>Notes: </strong>
								<ul>
									{formNotes.map((note, idx) => {
										return <li key={idx}>{note}</li>
									})}
								</ul>
							</p>

						</div>
						: null}


					{fileTemplates !== null ?
						<div className='col-12'>
							<p>Click <a href={fileTemplates}>Here</a> to download template</p>
						</div>
						: null}



					<div className="col-12">
						{attachmentMessages.length > 0 ?
							<>
								<label>Files to attach:  </label>
								<p style={{ fontWeight: 'normal', marginTop: 10, marginBottom: 10, }}>
									<ul>
										{attachmentMessages.map((message, idx) => <li key={idx}>{message}</li>)}
									</ul>
								</p>
							</>
							:
							<label>Files  *</label>
						}
						<div className="file-upload ">
							<div className="file-upload-btn" >
								<label style={formErrors.includes(`file`) ? { borderColor: 'red' } : {}} >

									<i className="bi bi-paperclip"></i>
									Attach File
								</label>
								<input
									type="file"
									id="file"
									name='file'
									accept=".jpeg,.jpg,.gif,.png,.pdf,.doc,.docx,.xls,.xlsx,.csv"
									multiple
									className="form-control"
									onChange={e => this.attachFileHandler(e)}
									disabled={formStatus.submitted}
								/>
							</div>
							<span className="text-muted"><i>{MSG.general}</i></span>
							<div className="attach-chips">
								{formData.file !== null && this.displayAttachedFiles()}
							</div>
						</div>
					</div>
				</div>

				<div className="row action-btn">
					<div className="col-12">
						<button
							style={{ float: 'right' }}
							type="button"
							data-bs-toggle="modal"
							data-bs-target="#successModal"

							onClick={e => this.submitForm(e)}
							disabled={formStatus.submitted}
						>

							{formStatus.submitted ?
								<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> &nbsp; Submitting... </>
								:
								<>
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.91396 10L2.88989 16.0933L16.4333 10L2.88989 3.90673L4.91396 10ZM2.61324 10L0.0483426 17.7214C-0.228127 18.5537 0.733799 19.2809 1.59727 18.8925L19.3907 10.8871C20.2031 10.5216 20.2031 9.47843 19.3907 9.11295L1.59726 1.10753C0.733796 0.719051 -0.228127 1.44632 0.048342 2.2786L2.61324 10Z" fill="#fff"></path><path fillRule="evenodd" clipRule="evenodd" d="M3 10C3 9.44772 3.44772 9 4 9L17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11L4 11C3.44772 11 3 10.5523 3 10Z" fill="#fff"></path></svg> SUBMIT </>
							}
						</button>
					</div>
				</div>


				<Modal show={submitModal.show} size='md' id="successModal" >
					{/* <Modal show={} size='md' id="successModal" > */}
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<h3>Thank you for submitting your query in C.H.E.E.R.</h3>
								<p>Please expect a member of our HR team to contact you shortly.</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeSubmitModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				<Modal show={requiredFieldModal.show} size='md' id="successModal" >
					<div className="modal-content" >
						<div className="modal-body text-center">
							<>
								<p style={{ fontWeight: 'normal', color: 'black', fontSize: 21 }}>
								<i class="bi bi-exclamation-circle"></i> All fields marked with red are mandatory.
								</p>
							</>

						</div>
						<div className="modal-footer">
							<button
								onClick={e => this.closeRequiredFieldModal(e)}
								type="button"
								className="btn btn-primary"
								data-bs-dismiss="modal"
								aria-label="Close"
							>
								<i className="bi bi-x-lg"></i>
							</button>
						</div>
					</div>
				</Modal>

				{formErrorModal.show &&
					<Modal show={formErrorModal.show} size='md' id="successModal" >
						{/* <Modal show={} size='md' id="successModal" > */}
						<div className="modal-content" >
							<div className="modal-body">
							{formErrorModal.message}
							</div>
							<div className="modal-footer">
								<button
									onClick={e => this.closeErrorModal(e)}
									type="button"
									className="btn btn-primary"
									data-bs-dismiss="modal"
									aria-label="Close"
								>
									<i className="bi bi-x-lg"></i>
								</button>
							</div>
						</div>
					</Modal>
				}

			</>
		)
			: <Spinner />
	}
}

export default EmaptaWorkspace;